import './FiletypeIcon.scss';

export { default } from './FiletypeIcon';
